export default "__VITE_PUBLIC_ASSET__ec4bcbdd__"